import { render } from "./MessageThreadItem.vue?vue&type=template&id=532a3542&scoped=true"
import script from "./MessageThreadItem.vue?vue&type=script&lang=js"
export * from "./MessageThreadItem.vue?vue&type=script&lang=js"

import "./MessageThreadItem.vue?vue&type=style&index=0&id=532a3542&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532a3542"]])

export default __exports__